import React from 'react'
import { Box } from '@hub/box'
import { H1, H3 } from '@hub/heading'
import { Text } from '@hub/text'
import { Link } from '@scentregroup/shared/link'
import { CoreContainer } from '@hub/core-container'
import { Stack } from '@hub/stack'
import useMobileBreakpoint from '@scentregroup/shared/helpers/use-mobile-breakpoint'

export const Headings: React.FunctionComponent<React.PropsWithChildren<{
  h1?: string
  h3?: string
}>> = ({ h1 = 'Westfield Digital Gift Card', h3 }) => {
  return (
    <Box
      display="flex"
      flexDirection={{
        base: 'column',
        md: 'row',
      }}
      justifyContent="space-between"
    >
      <H1 fontSize={{ base: 'font-2xl', md: 'font-4xl' }}>{h1}</H1>
      {h3 && (
        <H3
          fontSize={{ base: 'font-2xl', md: 'font-4xl' }}
          sx={{ marginTop: { base: 'spacing-xs', md: 0 } }}
          color="brand"
        >
          {h3}
        </H3>
      )}
    </Box>
  )
}

export const ReturnToWDStrip: React.FunctionComponent<React.PropsWithChildren<{ show: boolean }>> = ({
  show,
}) => {
  const isMobile = useMobileBreakpoint()
  if (!show) {
    return null
  }
  return (
    <Box
      sx={{
        backgroundColor: 'licorice',
      }}
    >
      <CoreContainer sx={{ position: 'relative', height: 'size-sm' }}>
        <Stack
          alignItems="center"
          align="center"
          justify="center"
          sx={{
            height: '100%',
            display: 'flex',
            flexGrow: '0',
          }}
        >
          <Text
            fontSize={isMobile ? 'font-sm' : 'font-md'}
            color="white"
            tone="strong"
            sx={{
              textAlign: 'center',
              flexDirection: 'row',
              alignItems: 'center',
              alignContent: 'center',
            }}
          >
            Welcome to Westfield Gift Cards. Purchase a Gift Card here or&nbsp;
            <span style={{ textDecoration: 'underline' }}>
              <Link to="/shop">return to Westfield Online</Link>.
            </span>
          </Text>
        </Stack>
      </CoreContainer>
    </Box>
  )
}
